import type { LocaleObject, NuxtI18nOptions } from '@nuxtjs/i18n/dist/module'
import { useProjectBuildConfig } from '../composables/useProjectConfig'
import { freezeLocales } from './i18n-config'
import type { Locale } from './i18n-config'

const { locales: projectLocales, defaultLocale: projectLocale, domain } = useProjectBuildConfig()

/** 语言类型 */
export type {
  Locale,
}

export const locales: LocaleObject[] = projectLocales.length === 0 ? [...freezeLocales] : [...freezeLocales].filter(e => projectLocales.includes(e.code))

export const defaultLocale = projectLocale

export function i18nOptions(): NuxtI18nOptions {
  return {
    locales,
    baseUrl: domain,
    lazy: true,
    langDir: 'locales',
    defaultLocale,

    compilation: {
      strictMessage: false,
      escapeHtml: false,
    },
    detectBrowserLanguage: false,
  }
}

/** 地区重定向 cookie-key */
export const LOCALE_REDIRECT_KEY = 'LOCALE_REDIRECT'
